module.exports = __webpack_public_path__ + "static/pdf-playbook-large-cf65321c493a35483610a4fd33421d9f.png";